import React from 'react';
import { ConfirmPaymentBtn, SubmitSection, TermsSection } from '../styles';

interface SubmitPaymentSectionProps {
  termsAccepted: boolean;
  onTermsAcceptedChange: (accepted: boolean) => void;
  isLoading: boolean;
  onSubmit: () => void;
}

export const SubmitPaymentSection: React.FC<SubmitPaymentSectionProps> = ({
  termsAccepted,
  onTermsAcceptedChange,
  isLoading,
  onSubmit,
}) => (
  <SubmitSection>
    <TermsSection>
      <label className="checkbox-container">
        <input
          type="checkbox"
          checked={termsAccepted}
          onChange={(e) => onTermsAcceptedChange(e.target.checked)}
        />
        <span className="terms-text">
          Ao clicar no botão acima, você concorda com nossos{' '}
          <a
            href="https://jusfy.com.br/client/assets/termos.pdf"
            target="_BLANK"
            rel="noreferrer"
          >
            Termos de Uso
          </a>{' '}
          |{' '}
          <a
            href="https://jusfy.com.br/client/assets/politica.pdf"
            target="_BLANK"
            rel="noreferrer"
          >
            Política de Privacidade
          </a>{' '}
          |{' '}
          <a
            href="https://jusfy.com.br/client/assets/politica-de-pagamento.pdf"
            target="_BLANK"
            rel="noreferrer"
          >
            Política de Pagamento
          </a>
          .
        </span>
      </label>
    </TermsSection>
    <ConfirmPaymentBtn type="button" onClick={onSubmit} disabled={isLoading || !termsAccepted}>
      {isLoading ? 'Processando...' : 'Confirmar e pagar'}
    </ConfirmPaymentBtn>
  </SubmitSection>
);
